// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"25697ab3","406":"e5b1a7e1"}[chunkId] + ".chunk.js";
};